/**
 * State used in rendering AvatarGroupItem
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
